// extracted by mini-css-extract-plugin
module.exports = {"card":"ourProcessPhotoCard_card__9xR53","isVisible":"ourProcessPhotoCard_isVisible__GC_I4","hide":"ourProcessPhotoCard_hide__2ai3u"};